import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { log } from 'util';
import * as moment from 'moment';
import { clientLog, serverLog, apiLink, apiGetAccount } from './util';
import { BrowserAuthError, createNestablePublicClientApplication } from "@azure/msal-browser";
import { createLocalUrl } from "./util";

import App from './components/App';
import Debugger from './components/Debugger';

import 'office-ui-fabric-react/dist/css/fabric.min.css';
import './styles.less';

const title = 'MailMerge365';

let isOfficeInitialized = false;
let initError = null;
let initEx = null;
let apiLinked = false;
let initMustSetup = false;
let exchangeItemID = null;
let userIdentityToken = null;
let userAccessToken = null;

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) {
        return match[2];
    }
    return null;
}

function setCookie(cname, cvalue) {
    var d = new Date();
    d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";secure=true;path=/;SameSite=Lax;";
}

const onReset = () => {
    clientLog("Reseting")
    initEx = null;
    initError = null;
    initMustSetup = false;
    apiLinked = false;
    exchangeItemID = null;
    userIdentityToken = null;
    userAccessToken = null;
    
    render(App);
    onSignIn();
}

const render = (Component) => {
    ReactDOM.render(
        <AppContainer>
            <Component
                onReset={onReset}
                apiLinked={apiLinked}
                title={title}
                itemID={exchangeItemID}
                userIdentityToken={userIdentityToken}
                isOfficeInitialized={isOfficeInitialized}
                initError={initError}
                initEx={initEx}
                initMustSetup={initMustSetup}
            />
        </AppContainer>,
        document.getElementById('container')
    );
};

const defaultInitErrorMessage = "There was an error starting the plugin. Client could not get token.";

const handleErrors = (method: string, result: Office.AsyncResult<any>, action: () => void) => {
    if (result.status != Office.AsyncResultStatus.Succeeded) {
        initError = defaultInitErrorMessage;
        render(App);
    }
    else {
        try {
            clientLog(`${method}: OK`);
            action();
        }
        catch (ex) {
            initError = defaultInitErrorMessage;
            render(App);
        }
    }
}

let pca = undefined;
const onSignIn = async () => {

    try {

        userIdentityToken = null;

        clientLog("Starting")

        render(App);

        let idToken = null;

        // Initialize the public client application
        pca = await createNestablePublicClientApplication({
            auth: {
                clientId: "d87015f3-71a7-42c3-80cb-5e0f636703ae",
                authority: "https://login.microsoftonline.com/organizations"
            },

        });


        const tokenRequest = {
            scopes: ["openid", "profile", "User.Read"], // copied in fallback
        };

        try {
            clientLog("[MSAL] Trying to acquire token silently...");
            const userAccount = await pca.acquireTokenSilent(tokenRequest);
            clientLog("[MSAL] Acquired token silently.");
            idToken = userAccount.idToken;
        } catch (error) {
            clientLog(`Unable to acquire token silently: ${JSON.stringify(error)}` /* this is not a client error */);
        }

        if (idToken === null) {
            // Acquire token silent failure. Send an interactive request via popup.
            try {
                clientLog("[MSAL] Trying to acquire token interactively...");
                const userAccount = await pca.acquireTokenPopup(tokenRequest);
                clientLog("[MSAL] Acquired token interactively.");
                idToken = userAccount.idToken;
            } catch (popupError) {

                // Optional fallback if about:blank popup should not be shown
                if (popupError instanceof BrowserAuthError && popupError.errorCode === "popup_window_error") {
                    idToken = await getTokenWithDialogApi();
                } else {
                    // Acquire token interactive failure.
                    clientLog(initError = `Unable to acquire token interactively: ${JSON.stringify(popupError)}`);
                }
            }
        }

        // Log error if both silent and popup requests failed.
        if (idToken === null) {
            initError = initError || `Unable to acquire access token.`;
            render(App);
        } else {

            var decoded = decodeJwtExpiration(idToken);
            if (decoded) {
                clientLog("Token received which expires at: " + decoded.expirationDate);
            }
            userIdentityToken = idToken;
            Office.context.mailbox.item.saveAsync(onAfterSaveItem);
        }

    } catch (ex) {
        clientLog("Error onSignIn")
        clientLog(ex)
        initError = defaultInitErrorMessage;
        initEx = JSON.stringify(ex);
        
        render(App);
    }
};

function decodeJwtExpiration(token) {
    try {
        // Validate input
        if (!token || typeof token !== 'string') {
            clientLog('Invalid token: must be a non-empty string');
            return null;
        }

        // Split the JWT into its three parts
        const parts = token.split('.');
        if (parts.length !== 3) {
            clientLog('Invalid JWT format: must have 3 parts separated by dots');
            return null;
        }

        // Get the payload (middle part)
        const payload = parts[1];

        // Base64url decode the payload
        // Base64url is like base64 but with URL-safe characters
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');

        // Add padding if needed
        const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);

        // Decode and parse JSON
        const decodedPayload = JSON.parse(atob(padded));

        // Check if exp claim exists
        if (!decodedPayload.exp) {
            clientLog('Token does not contain an expiration (exp) claim');
            return null;

        }

        // Convert Unix timestamp to JavaScript Date
        const expirationDate = new Date(decodedPayload.exp * 1000);

        // Validate the date
        if (isNaN(expirationDate.getTime())) {
            clientLog('Invalid expiration timestamp');
            return null;
        }

        return {
            expirationDate: expirationDate,
            expirationTimestamp: decodedPayload.exp,
            isExpired: Date.now() > expirationDate.getTime(),
            timeUntilExpiration: expirationDate.getTime() - Date.now(),
            payload: decodedPayload // Return full payload for reference
        };

    } catch (error) {
        clientLog(`Failed to decode JWT expiration: ${error.message}`);
        return null;

    }
}


/** FALLBACK FOR NAA */
export type AuthDialogResult = {
    idToken?: string;
    error?: string;
};

var _dialogApiResult: Promise<string> | null = null;

type DialogEventMessage = { message: string; origin: string | undefined };
type DialogEventError = { error: number };
type DialogEventArg = DialogEventMessage | DialogEventError;

const getTokenWithDialogApi: () => Promise<string> = () => {
    _dialogApiResult = new Promise((resolve, reject) => {
        Office.context.ui.displayDialogAsync(createLocalUrl(`dialog.html`), { height: 60, width: 30 }, (result) => {
            result.value.addEventHandler(Office.EventType.DialogEventReceived, (arg: DialogEventArg) => {
                const errorArg = arg as DialogEventError;
                if (errorArg.error == 12006) {
                    _dialogApiResult = null;
                    reject("Login window closed");
                }
            });
            result.value.addEventHandler(Office.EventType.DialogMessageReceived, (arg: DialogEventArg) => {
                const messageArg = arg as DialogEventMessage;
                const parsedMessage = JSON.parse(messageArg.message);
                result.value.close();

                if (parsedMessage.error) {
                    reject(parsedMessage.error);
                    _dialogApiResult = null;
                } else {
                    resolve(parsedMessage.idToken);
                }
            });
        });
    });
    return _dialogApiResult;
}
/** END FALLBACK FOR NAA */

const onAfterSaveItem = (result: Office.AsyncResult<string>) => {
    handleErrors("onAfterSaveItem", result, () => {
        exchangeItemID = result.value
        Debugger.appendLog("exchangeItemID:" + exchangeItemID);
        linkToApi();
    });
}

const linkToApi = () => {
    try {
        // Ready for deprecation
        var restUrl = "";
        //try {
        //	restUrl = Office.context.mailbox.restUrl;
        //} catch { }

        apiLink(
            window.location.href,
            userIdentityToken,
            userAccessToken,
            restUrl,
            Office.context.mailbox.diagnostics.hostName
        )
            .then(onAfterServerLink)
            .catch((ex) => {
                initEx = JSON.stringify({
                    response: ex?.response?.data,
                    axios: ex
                });
                initError = defaultInitErrorMessage;
                render(App);
            })
    }
    catch (ex) {
        initEx = JSON.stringify(ex);
        initError = defaultInitErrorMessage;
        render(App);
    }
}

var retriedAuth = false;
var previousToken = "";
const onAfterServerLink = async (linkResult) => {

    if (linkResult.success === true) {
        clientLog("onAfterServerLink: OK");
        apiLinked = true;
    }
    else {
        if (linkResult.completeSetup) {
            clientLog("Account problem in onAfterServerLink: " + linkResult.reason);
            initMustSetup = true;
            apiLinked = true;
        }
        else if (linkResult.reAuth) {
            

            if (!retriedAuth) {
                previousToken = userIdentityToken;
                clientLog("Invalid token in onAfterServerLink: " + linkResult.reason);
                retriedAuth = true;

                // Clear all local cookies, local storage and sessions with try catch around each
                try {
                    // Remove every cookie
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        var cookie = cookies[i];
                        var eqPos = cookie.indexOf("=");

                        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                        name = name.trim();
                        if (name.length > 0) {
                            document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax; secure=true;";
                        }
                    }
                } catch (e) { }
                try {
                    localStorage.clear();
                } catch (e) { }
                try {
                    sessionStorage.clear();
                } catch (e) { }


                onSignIn();
            } else {

                clientLog("Invalid token twice in onAfterServerLink: " + linkResult.reason);
                initEx = JSON.stringify({
                    ...linkResult, userIdentityToken, previousToken
                });
                initError = "There was a problem signing-in to your account. Re-auth was attempted but failed. " + linkResult.reason;

                try {
                    userIdentityToken = await getTokenWithDialogApi();
                    if (userIdentityToken) {
                        initEx = null;
                        initError = null;
                        onSignIn();
                    }
                } catch (ex) {
                    clientLog("getTokenWithDialogApi failed: " + ex?.message);
                }
            }

        }
        else {
            clientLog("Error in onAfterServerLink: " + linkResult.reason);
            initEx = JSON.stringify(linkResult);
            initError = "There was a problem signing-in to your account. " + linkResult.reason;
        }
    }

    render(App);
}

try {
    var locale = (window.navigator as any).userLanguage || window.navigator.language;
    moment.locale(locale)

    initializeIcons();

    var utm_source = getUrlParameter("utm_source");
    var utm_medium = getUrlParameter("utm_medium");
    var utm_content = getUrlParameter("utm_content");
    var utm_campaign = getUrlParameter("utm_campaign");
    var utm_term = getUrlParameter("utm_term");
    var referer_qs = getUrlParameter("referer");
    var referer_doc = (document.referrer && encodeURIComponent(document.referrer));

    if (utm_source && utm_source.length > 0) setCookie("utm_source", utm_source);
    if (utm_medium && utm_medium.length > 0) setCookie("utm_medium", utm_medium);
    if (utm_content && utm_content.length > 0) setCookie("utm_content", utm_content);
    if (utm_campaign && utm_campaign.length > 0) setCookie("utm_campaign", utm_campaign);
    if (utm_term && utm_term.length > 0) setCookie("utm_term", utm_term);
    if (referer_qs && referer_qs.length > 0) {
        setCookie("referer", referer_qs);
    } else if ((getCookie('referer') || '').length == 0 && referer_doc && referer_doc.length > 0) {
        setCookie("referer", referer_doc);
    }

    /* Render application after Office initializes */
    Office.initialize = () => { };

    Office.onReady(function (info) {
        isOfficeInitialized = true;
        onSignIn();
    });


    /* Initial render showing a progress bar */
    render(App);

    //if ((module as any).hot) {
    //    (module as any).hot.accept('./components/App', () => {
    //        const NextApp = require('./components/App').default;
    //        render(NextApp);
    //    });
    //}

} catch (ex) {
    var body = document.querySelector("body");
    var errContent = "<div style='padding: 20px; text-align: center; display: flex; flex-direction: column; justify-content: center; align-items: center;'><b>Error:</b><span>" + ex + "</span></div>";
    if (body) {
        body.innerHTML = errContent;
    } else {
        document.write(errContent)
    }
}